import { optionalString, string, zodLess, ZodLessInfer } from '@kaiizen/zod-less';

export const StreetViewImageRequestQuerySchema = zodLess({
  address: string,
  width: optionalString.describe('width of the image. e.g. 600'),
  height: optionalString.describe('height of the image. e.g. 400'),
  heading: optionalString.describe('only used if useHeadingOverride is true'), // only used if useHeadingOverride is true
  pitch: optionalString.describe('recommended default to look up at the house'), // recommended default to look up at the house
  fov: optionalString.describe('recommended default'), // recommended default
}, { ref: 'streetViewImageRequestPayload' });
export type StreetViewImageRequestPayload = ZodLessInfer<typeof StreetViewImageRequestQuerySchema>;
